import React, { useState } from 'react';
import { Share2, Check, Copy } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

export default function ShareButtons({ listing }) {
  const { t } = useLanguage();
  const [copied, setCopied] = useState(false);
  const url = window.location.href;
  const text = `${listing.title} - ${listing.currentPrice}€ | Biet Es Runter`;

  const copy = () => {
    navigator.clipboard.writeText(url).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); });
  };

  const shares = [
    {
      label: 'WhatsApp',
      color: 'bg-[#25D366] hover:bg-[#20b955]',
      icon: '💬',
      href: `https://wa.me/?text=${encodeURIComponent(text + '\n' + url)}`,
    },
    {
      label: 'X (Twitter)',
      color: 'bg-black hover:bg-gray-800',
      icon: '✕',
      href: `https://x.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
    },
    {
      label: 'Facebook',
      color: 'bg-[#1877F2] hover:bg-[#0f65d8]',
      icon: 'f',
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    },
  ];

  return (
    <div>
      <div className="flex items-center gap-2 mb-3">
        <Share2 className="w-4 h-4 text-apple-gray-mid" />
        <span className="text-sm font-medium text-apple-gray-dark">{t('share.title')}</span>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        {shares.map(s => (
          <a
            key={s.label}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex items-center gap-1.5 px-3 py-2 rounded-full text-white text-xs font-medium transition-colors ${s.color}`}
          >
            <span className="text-xs">{s.icon}</span> {s.label}
          </a>
        ))}
        <button
          onClick={copy}
          className="flex items-center gap-1.5 px-3 py-2 rounded-full bg-apple-gray hover:bg-gray-200 text-apple-gray-dark text-xs font-medium transition-colors"
        >
          {copied ? <Check className="w-3 h-3 text-apple-green" /> : <Copy className="w-3 h-3" />}
          {copied ? t('share.copied') : t('share.copy_link')}
        </button>
      </div>
    </div>
  );
}
